import React from 'react';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components';

import { assetUrl } from '~/helpers';
import { useTranslation } from 'react-i18next';

export interface PoweredByBonjoroBadgeProps {
  className?: string;
  onButtonClick?: () => void;
}

export default function PoweredByBonjoroBadge({
  className = '',
  onButtonClick,
}: PoweredByBonjoroBadgeProps) {
  const { t } = useTranslation();
  return (
    <div
      className={`grid grid-cols-2 place-content-center gap-x-4 bg-white bg-opacity-50 p-5 rounded-2xl md:flex md:flex-row md:items-center md:gap-x-5 ${className}`}
    >
      <img
        className='order-last w-32 md:order-first md:w-36'
        src={assetUrl('assets/images/badges/powered-by-bj.svg')}
      />
      <h4 className='col-span-2 text-neutral-700 font-bold my-5 text-sm xsm:text-base sm:text-lg md:my-0 md:text-xl'>
        {t('bonjoro:badge.create')}
      </h4>
      <Button
        className='text-base w-32 md:w-auto'
        variant={ButtonVariant.Primary}
        onClick={onButtonClick}
      >
        {t('bonjoro:badge.cta')}
      </Button>
    </div>
  );
}
